import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Inner from './Inner';

interface MenuItem {
  value: string;
  label: string;
  count: number;
  isRefined: boolean;
}

const SearchTopicalTypeFacet: React.FC<{ className?: string; }> = ({ className }) => {
  const { t } = useTranslation();

  const transformedItems = useCallback((items: MenuItem[]) => {
    items.push({
      value: '__all__',
      label: '__all__',
      count: 0,
      isRefined: false,
    });

    return items.map((item) => ({
      ...item,
      label: t(`components.search.facets.label_replacements.${item.value}`),
    }));

    // We only want to transform these items on mount, to prevent unnecessary rerenders.
    // However, linting wants to force us to add "t" as a dependency. That's why we disable it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Inner
      className={className}
      attribute="type"
      sortBy={['name:asc']}
      transformItems={transformedItems}
    />
  );
};

export default SearchTopicalTypeFacet;
